/** @jsx jsx */

import * as React from "react";
import { AnyAction } from "redux";
import CustomSelect from "../../CustomSelect";
import Dropdown from "../../Dropdown";
import TextInput from "../../TextInput";
import TypeAhead, { TypeAheadElement } from "../../TypeAhead";
import { css, jsx } from "@emotion/core";
import { familyHistoryStyles } from "../../../styles/components/ongoing/History/familyHistory"


interface IAddedHistory {
    allergen: {
        additionalInfo: string;
        displayValue: string;
        internalValue: string;
    },
    allergenType: string;
    q: {
        displayValue: string;
        internalValue: string;
    },
    updatingMethod: string;
    validSection: boolean;
    isSuspected: boolean;
    comments: string;
}

interface IAllergyHistoryProps {
    onTypeAheadChange: (input: string, typeAheadConfig: any) => Promise<any>;
    handleItemChange(updatedItem: any, index: number): void;
    listItems: any[];
}

interface IAllergyHistoryState {
    shouldShowTypeAhead: boolean;
    isReadOnly: boolean;
    selectedItems: Array<IAddedHistory>;
    typeAheadVal: string
}



export class AllergyHistory extends React.Component<IAllergyHistoryProps, IAllergyHistoryState> {


    constructor(props: IAllergyHistoryProps) {
        super(props);
        const selectedItems = [...props.listItems.map(({ item }) => item)]
        this.state = {
            shouldShowTypeAhead: selectedItems.length <= 0,
            isReadOnly: selectedItems.length > 0,
            typeAheadVal: "",
            selectedItems
        }
    }

    private allergenType: any[] = [{
        "internalValue": "Food",
        "displayValue": "FOOD"
    }, {
        "internalValue": "Environmental",
        "displayValue": "ENVIRONMENTAL"
    }, {
        "internalValue": "Drugs",
        "displayValue": "DRUG"
    }];

    onTypeAheadSelect = (elem: TypeAheadElement, idx?: number, noOfKeystrokes?: number, event?: any, searchKeyword?: string) => {
        const newlyAddedItem: IAddedHistory = {
            allergen: {
                displayValue: elem.label,
                internalValue: elem.value,
                additionalInfo: elem.additionalInfoLabel
            },
            allergenType: undefined,
            isSuspected: false,
            comments: undefined,
            q: {
                displayValue: elem.label,
                internalValue: elem.value,
            },
            updatingMethod: "TYPE_AHEAD",
            validSection: true
        }

        const selectedItems = this.state.selectedItems;
        selectedItems.push(newlyAddedItem);
        this.setState({ selectedItems, shouldShowTypeAhead: false });
    }

    onTypeAheadChange = (input: string) => {
        this.setState({ typeAheadVal: input });
        const typeAheadConfig = {
            "source": "MAVERICK",
            "url": "/maverick/care/allergies_catalogue",
            "appendQueryString": true,
            "otherKeysMapping": {},
            "additionalInfoLabelKeys": ["type"],
            "valueKey": "displayValue",
            "labelKey": "displayValue",
            "internalKey": "internalValue",
            "inputParam": "q",
            "resultMapper": [{
                "internalValue": "internalValue",
                "displayValue": "displayValue"
            }]
        };
        return this.props.onTypeAheadChange(input, typeAheadConfig);
    }

    onAllergenTypeChange = (value: string, ObjectIndex: number) => {
        const selectedItems: IAddedHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            selectedItems[ObjectIndex].allergenType = value;
            this.setState({ selectedItems });
        }
    }

    onSuspectedSelect = (ObjectIndex: number) => {
        const selectedItems: IAddedHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            const currentValue: boolean = selectedItems[ObjectIndex].isSuspected;
            selectedItems[ObjectIndex].isSuspected = !currentValue;
        }
        this.setState({ selectedItems });
    }

    onCommentsChange = (event: React.ChangeEvent<HTMLInputElement>, ObjectIndex: number) => {
        const value: string = event.target.value;
        const selectedItems: IAddedHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            selectedItems[ObjectIndex].comments = value;
            this.setState({ selectedItems });
        }
    }

    removeAllergen = (ObjectIndex: number) => {
        const selectedItems: IAddedHistory[] = this.state.selectedItems;
        selectedItems.splice(ObjectIndex, 1);
        this.setState({ selectedItems });
    }

    addNewDisease = () => {
        this.setState({ shouldShowTypeAhead: true });
    }
    save = () => {
        this.state.selectedItems.forEach((item, index) => {
            this.props.handleItemChange(item, index);
        });
        this.setState({ isReadOnly: true, shouldShowTypeAhead: false });
    }

    edit = () => {
        this.setState({ shouldShowTypeAhead: true, isReadOnly: false });
    }
    render() {
        const { shouldShowTypeAhead, isReadOnly, selectedItems, typeAheadVal } = this.state;
        return <div>
            <button css={familyHistoryStyles.allergyEdit} onClick={this.edit}>
                <span className="glyphicon glyphicon-pencil" css={familyHistoryStyles.editIcon}></span>
                <span>Edit</span>
            </button>
            {shouldShowTypeAhead &&
                <div css={familyHistoryStyles.commonlyUsedComntainer}>
                    <div>
                        <div css={familyHistoryStyles.tagsHeader}>COMMONLY USED</div>
                        <div></div>
                    </div>
                    <div css={familyHistoryStyles.typeAheadContainer}>
                        <TypeAhead value={typeAheadVal} placeholder="Select Disease Name" onTypeAheadChange={this.onTypeAheadChange}
                            onTypeAheadSelect={this.onTypeAheadSelect} />
                    </div>
                </div>
            }
            {!isReadOnly &&
                <div>
                    {
                        selectedItems.map((item: IAddedHistory, ObjectIndex: number) => {
                            let { allergen, allergenType, comments, isSuspected } = item;
                            return <div css={familyHistoryStyles.selectedDiseaseRow} key={ObjectIndex}>
                                <div css={familyHistoryStyles.verticalMiddle}>{allergen.displayValue}</div>
                                <div css={familyHistoryStyles.itemsContainer}>
                                    <div css={familyHistoryStyles.itemsWrapper}>
                                        <CustomSelect dropdownValues={this.allergenType} selectedValue={allergenType} defaultValue="Type" updateDropdownValue={(value) => this.onAllergenTypeChange(value, ObjectIndex)} />
                                        <button onClick={() => this.onSuspectedSelect(ObjectIndex)} css={isSuspected ? familyHistoryStyles.selectedBtn : familyHistoryStyles.relationshipBtns}>Suspected</button>
                                        <TextInput placeholder="Comments" value={comments} onChange={(e) => this.onCommentsChange(e, ObjectIndex)} />
                                        <div css={familyHistoryStyles.actionWrapper}>
                                            <div>
                                                <span className="glyphicon glyphicon-trash" css={familyHistoryStyles.icons} onClick={() => this.removeAllergen(ObjectIndex)}></span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
            }
            {isReadOnly &&
                <div>
                    {
                        selectedItems.map((item: IAddedHistory, ObjectIndex: number) => {
                            let { allergen, allergenType, comments, isSuspected } = item;
                            return <div css={familyHistoryStyles.readOnlyRow} key={ObjectIndex}>
                                <div css={familyHistoryStyles.verticalMiddle}>{allergen.displayValue}</div>
                                <div css={familyHistoryStyles.itemsContainer}>
                                    <div css={familyHistoryStyles.itemsWrapperReadOnly}>
                                        <div>{allergenType} | </div>
                                        <div> {isSuspected && "Suspected"} | </div>
                                        <div>{comments}</div>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
            }
            {!isReadOnly
                &&
                <div css={familyHistoryStyles.bottonCta}>
                    <button onClick={this.addNewDisease} css={familyHistoryStyles.transparentBtn}>
                        <span className="glyphicon glyphicon-plus-sign" css={familyHistoryStyles.icons}></span>
                        Add New
                    </button>
                    {selectedItems.length > 0 &&
                        <button css={familyHistoryStyles.selectedBtn} onClick={this.save}>Save</button>
                    }
                </div>
            }

        </div>
    }


}